// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck.ck-placeholder:before,.ck .ck-placeholder:before{\n  content:attr(data-placeholder);\n  pointer-events:none\n}\n\n.ck.ck-read-only .ck-placeholder:before{\n  display:none\n}\n\n.ck.ck-placeholder:before,.ck .ck-placeholder:before{\n  color:var(--ck-color-engine-placeholder-text)\n}\n\n[dir] .ck.ck-placeholder:before, [dir] .ck .ck-placeholder:before{\n  cursor:text\n}", ""]);
// Exports
module.exports = exports;
